import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import '../styles/eraser.scss';
import ButtonComponent from './ButtonComponent';
import { DataContext } from '../player/DataContext';
import { leftSideTools } from '../interface/gameController';
import Popup from './Popup';
import { t } from 'i18next';
var Eraser = function () {
    var _a = useContext(DataContext), setDrawCommands = _a.setDrawCommands, tool = _a.tool, setTool = _a.setTool;
    var _b = useState(true), isOpen = _b[0], setIsOpen = _b[1];
    var onBtnClick = function (type) {
        switch (type) {
            case 'cancel':
                break;
            case 'clear':
                setDrawCommands([]);
                break;
            default:
                break;
        }
        setTool(leftSideTools.selection);
    };
    return (_jsx(Popup, { isOpen: isOpen, onClose: function () {
            setIsOpen(false);
            setTool(leftSideTools.selection);
        }, className: "className-eraserPopup", children: _jsx("div", { className: "eraserWrapper", children: _jsxs("div", { className: "container", children: [_jsxs("div", { className: "upperPart", children: [_jsx("div", { className: "title", children: t('text.eraseAllText') }), _jsxs("div", { className: "btnContainer", children: [_jsx(ButtonComponent, { type: "textType1", text: t('text.cancel'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: function () { return onBtnClick('cancel'); } }), _jsx(ButtonComponent, { type: "textType1", text: t('text.clearAll'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: function () { return onBtnClick('clear'); } })] })] }), _jsx("div", { className: "footerImageHolder", style: { backgroundImage: 'url(./assets/images/shareColourPatches.svg)' } })] }) }) }));
};
export default Eraser;
